import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=4d433551&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=4d433551&prod&lang=scss&"
import style1 from "./TextEditor.vue?vue&type=style&index=1&id=4d433551&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d433551",
  null
  
)

export default component.exports